import React from 'react'

function HelpPage() {
  return (
    <div>HelpPage</div>
  )
}

export default HelpPage